import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-demosplash',
  templateUrl: './demosplash.component.html',
  styleUrls: ['./demosplash.component.css']
})
export class DemosplashComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
